import { Router } from 'preact-router';

import About from '@/pages/About';
import Links from '@/pages/Links';
import Thoughts from '@/pages/Thoughts';
import Art from '@/pages/Art';
import Photo from '@/pages/Photo';
import Concept from '@/pages/Photo/Concept';
import Macro from '@/pages/Photo/Macro';
import People from '@/pages/Photo/People';
import Scene from '@/pages/Photo/Scene';
import Sky from '@/pages/Photo/Sky';
import Manip from '@/pages/Manip';
import Draw from '@/pages/Drawings';
import Fourohfour from '@/pages/Fourohfour';

import * as styles from './routing.css';

export default function Routing() {
  return (
    <div class={styles.routing}>
      <Router>
        <About path="/" />
        <Links path="/links" />
        <Thoughts path="/thoughts" />
        <Art path="/art" />
        <Photo path="/photos" />
        <Concept path="/photos/concept" />
        <Macro path="/photos/macro" />
        <People path="/photos/people" />
        <Scene path="/photos/scene" />
        <Sky path="/photos/sky" />
        <Manip path="/manip" />
        <Draw path="/drawings" />
        <Fourohfour type="404" default />
      </Router>
    </div>
  );
}
